export default __webpack_public_path__ + "static/media/Beard_8_C2.f387e465.svg";